import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'worker_code',
      label: i18n.t('labor.worker_code'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'worker_name',
      label: `${i18n.t('common_words.name')} ${i18n.t('labor.worker')}`,
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'payment_period_name',
      label: i18n.t('labor.payment_frequency'),
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'total',
      label: `${i18n.t('common_words.total')} ${i18n.t(
        'labor.payment_frequency'
      )}`,
      minWidth: 210,
      align: 'center',
      formatter: (row, column) => {
        return `$${Formatter.formatNumber(Number(row[column.property]))}`;
      },
    },
    {
      prop: 'labor_header_date_save',
      label: i18n.t('common_words.date'),
      minWidth: 120,
      sortable: true,
    },
    {
      prop: 'activities_name',
      label: `${i18n.t('common_words.name')} ${i18n.t(
        'common_words.activity'
      )}`,
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'unit_payment_name',
      label: i18n.t('labor.unit'),
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'quantity',
      label: i18n.t('common_words.quantity'),
      minWidth: 100,
      sortable: true,
      align: 'center',
      formatter: (row, column) => {
        return Formatter.formatNumber(Number(row[column.property]));
      },
    },
    {
      prop: 'sub_total',
      label: i18n.t('common_words.sub_total'),
      minWidth: 180,
      align: 'center',
      formatter: (row, column) => {
        return `$${Formatter.formatNumber(Number(row[column.property]))}`;
      },
    },
  ];

  return { Table };
};

export default configTable;
